module.exports = __webpack_public_path__ + "img/right1.0091f02c.png";